import { Box } from "@mui/material";
import { useAppTranslation } from "../../../../hooks/useAppTranslation";
import Persons from "../../../../common/persons/persons.component";
import Title from "../../../../common/title/title.components";
import { organizersMobileImages } from "../../../../constant/organizers-images.constant";
import { PersonItemModel } from "../../../../types/person-item.type";
import StyledWrapper from "./organizers-section.styles";

const OrganizersSection = () => {
  const { t } = useAppTranslation();
  const organizers = t("organizers.organizersList", { returnObjects: true }) as PersonItemModel[];

  return (
    <StyledWrapper>
      <Box className="overlay"></Box>
      <Box className="organizers-content">
        <Title className="organizers-title" text={t("organizers.title")} />
        <Persons
          imgList={organizersMobileImages}
          personList={organizers}
          integratedType="organizer"
        />
      </Box>
    </StyledWrapper>
  );
};

export default OrganizersSection;
